/* eslint-disable no-console */
import useJSONStore from '../../../../../store/StaticJson/jsonStore';
import useUserStore from '../../../../../store/userStore/userStore';
import {UserRole} from '../../../../../utils/commonFunctions';
// import {eachWordCapOrAllCap} from '../../../../../utils/FormUtils/FirstCap';

import {newLabels} from './commonConst';

export const filterPermissionsAndModules: (
  obj: any,
  statusString: string
) => any = (obj, statusString) => {
  const filter = (input: any) => {
    if (Array.isArray(input)) {
      return input.filter(
        (item) => item?.permissionType?.includes(statusString)
      );
    } else if (typeof input === 'object' && input !== null) {
      const filteredObj: any = {};
      for (const key in input) {
        if (input.hasOwnProperty(key)) {
          const filteredValue = filter(input[key]);
          if (Array.isArray(filteredValue) && filteredValue.length > 0) {
            filteredObj[key] = filteredValue;
          } else if (
            typeof filteredValue === 'object' &&
            Object.keys(filteredValue).length > 0
          ) {
            filteredObj[key] = filteredValue;
          }
        }
      }

      return filteredObj;
    }

    return input;
  };

  return filter(obj);
};

export const roleFilter = (): any[] => {
  const roleTypes = useJSONStore.getState().roleTypes;
  const userRole = useUserStore.getState().userRoles.find((i: string) => {
    return !i.startsWith('access');
  });

  switch (userRole) {
    case UserRole.Company_Admin:
      return roleTypes.map((i) => {
        return i.name;
      });
    case UserRole.Company_user:
      return roleTypes
        .filter((i) => {
          return [
            // UserRole.Company_user,
            UserRole.Facility_Admin,
            UserRole.Facility_User
          ].includes(i.name);
        })
        .map((i) => {
          return i.name;
        });
    case UserRole.Facility_Admin:
      return roleTypes
        .filter((i) => {
          return [
            // UserRole.Facility_Admin,
            UserRole.Facility_User
          ].includes(i.name);
        })
        .map((i) => {
          return i.name;
        });

    default:
      return [];
  }
};

export const extractPrefixSet = (arr: string[]): any => {
  const result: any = {};

  arr.forEach((str) => {
    const parts = str?.split(':');
    let prefix = '';

    for (let i = 0; i < parts?.length - 1; i++) {
      prefix += i === 0 ? parts[i] : `:${parts[i]}`;
      result[prefix] = true;
    }
  });

  return result;
};

export const returnSingleNewLabel = (
  description: string,
  checkInLowerCase: boolean = false
): string => {
  return (
    newLabels.find((newLabel) => {
      return checkInLowerCase
        ? newLabel?.key.toLowerCase() === description.toLowerCase()
        : newLabel?.key === description;
    })?.label ?? description
  );
};
